import { Link } from "wouter";
export default function NotFound() {
  return (
    <div style={{ padding: 40, textAlign: "center", color: "#fff" }}>
      <h1>404 — Not Found</h1>
      <p>The page you're looking for doesn't exist.</p>
      <Link href="/">Go Home</Link>
    </div>
  );
}
